import { PageContent } from "./PageContent";

type InformativePageProps = {
  page: any;
};

export function InformativePage({ page }: InformativePageProps) {
  return <PageContent page={page} />;
}
